

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class ErrorDialog extends Vue {
  show = false;
  item: any = {};

  get dialogs() {
    return this.$store.getters.vueDialogItems;
  }

  @Watch("dialogs", { deep: true, immediate: true })
  onDialogsWatch(val) {
    if (val && val.length > 0) {
      this.show = true;
      this.item = val[0];
    } else {
      this.show = false;
      this.item = {};
    }
  }

  onClickBackground() {
    // close dialog
    this.$util.close({ id: this.item._id }).then(() => {
      this.show = false;
    });
  }
}
